import { Button, Drawer, Form, Space, Spin, Tag } from "antd";
import { Component } from "react";
import "../styles/general.css";

import { POST, UPDATE } from "../constants/request-type";
import { mailing, user } from "../constants/routes";
import { logo_url, service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import { acceptedProfile, rejectedProfile } from "../mails/mail-type";

import userIcon from "../../assets/user.png";

import logger from '../../utils/logger.js';
const token = sessionStorage.getItem("auth_token");

class Order_details extends Component {
  state = {
    visible: false,
    list2: [],
    pic: null,
    load: false
  };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };
  handleImage = (e) => {
    e.preventDefault();
    return this.setState({ pic: e.target.files[0] });
  };
  getData = async () => {};

  handleAccept = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: user + "/" + "update-user-admin" + "/" + this.props.row._id,
      data: {
        visible: true,
        status: true
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }

    const request_details_mail = {
      type: POST,
      url: service_api,
      route: mailing + "/" + "send-email",
      data: {
        email: this.props.row.email,
        subject: "Profile Live on Panichef",
        html: acceptedProfile({
          fullname: this.props.row.firstname + " " + this.props.row.lastname,
          logo: logo_url
        })
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details_mail);
      logger.log("Envoie terminé");
    } catch (err) {

      return openNotificationWithIcon("error", `${err.response.data.message}`);
    }

    openNotificationWithIcon("success", "Super ! vous avez un profile LIVE");

    return setTimeout(() => window.location.reload(), 1000);
  };

  handleRejected = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    if (this.state.rejection_message.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez fournir une raison de rejet"
      );
    }

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: user + "/" + "update-user-admin" + "/" + this.props.row._id,
      data: {
        visible: false,
        status: true
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }

    const request_details_mail = {
      type: POST,
      url: service_api,
      route: mailing + "/" + "send-email",
      data: {
        email: this.props.row.email,
        subject: "Profile Rejection on Panichef",
        html: rejectedProfile({
          fullname: this.props.row.firstname + " " + this.props.row.lastname,
          reason: this.state.rejection_message,
          logo: logo_url
        })
      },
      token: token
    };

    try {
      await MakeRequestAsync(request_details_mail);
      logger.log("Envoie terminé");
    } catch (err) {

      return openNotificationWithIcon("error", `${err.response.data.message}`);
    }

    openNotificationWithIcon("success", "L'utilisateur sera notifié");

    return setTimeout(() => window.location.reload(), 1000);
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { load } = this.state;

    const { row } = this.props;
    return (
      <>
        <Button type="default" onClick={this.showDrawer}>
          Voir Details
        </Button>
        <Drawer
          title="Fiche du chef"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Retour
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <h2
              style={{
                marginTop: 20
              }}
            >
              Détails de la commande
            </h2>
            <h2
              style={{
                marginTop: 20
              }}
            >
              Articles
            </h2>
            {row?.food?.map((item) => (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row"
                }}
              >
                <a href={item?.pic} target="_blank">
                  <img
                    src={item?.pic}
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: "contain"
                    }}
                    alt={"food-logo"}
                  />
                </a>
                <br />
                <span>
                  <b>{item?.name}</b>
                </span>
                <br />
                <span>
                  Qty:<b>{item?.qty}</b>
                </span>
                <br />
                <span>
                  Coût: <b>${item?.cost * item?.qty}</b>
                </span>
              </div>
            ))}
            <h2
              style={{
                marginTop: 20
              }}
            >
              Chef - Client - Livreur
            </h2>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 30,
                padding: 10
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row"
                }}
              >
                {/* chef details */}

                <div>
                  <img
                    src={row?.chef_id?.pic1}
                    alt="chef-pic"
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: 50
                    }}
                  />
                  <br />

                  <span>
                    {row?.chef_id?.firstname + " " + row?.chef_id?.lastname}
                  </span>
                  <br />
                  <span>{row?.chef_id?.email}</span>
                  <br />
                  <span>{row?.chef_id?.number}</span>
                </div>
                {/* customer details */}

                <div>
                  {row?.user_id?.pic1 !== null && (
                    <img
                      src={row?.user_id?.pic1}
                      alt="client-pic"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50
                      }}
                    />
                  )}
                  {row?.user_id?.pic1 === null && (
                    <img
                      src={userIcon}
                      alt="client-pic"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50
                      }}
                    />
                  )}
                  <br />
                  <span>
                    {row?.user_id?.firstname + " " + row?.user_id?.lastname}
                  </span>
                  <br />
                  <span>{row?.user_id?.email}</span>
                  <br />
                  <span>{row?.user_id?.number}</span>
                </div>

                {/* deliverman details */}
                {row?.deliverman_id === null ? (
                  "Aucun livreur"
                ) : (
                  <div>
                    <img
                      src={row?.deliverman_id?.pic}
                      alt="deliverman-pic"
                      style={{
                        width: 100,
                        height: 100,
                        borderRadius: 50
                      }}
                    />
                    <br />

                    <span>
                      {row?.deliverman_id?.firstname +
                        " " +
                        row?.deliverman_id?.lastname}
                    </span>
                    <br />
                    <span>{row?.deliverman_id?.email}</span>
                    <br />
                    <span>{row?.deliverman_id?.number}</span>
                  </div>
                )}
              </div>
              <h2
                style={{
                  marginTop: 20
                }}
              >
                Rating Plat & Livraison
              </h2>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row"
                }}
              >
                {/* food rate */}
                {row?.rate_food?.rate === null ? (
                  <p>Aucune note de plat disponible</p>
                ) : (
                  <div
                    style={{
                      width: 150
                    }}
                  >
                    <Tag>
                      <span>{row?.rate_food?.rate + " étoiles"}</span>
                      <br />
                      <span>{row?.rate_food?.text}</span>
                    </Tag>
                  </div>
                )}
                {/* driver rate */}
                {row?.rate_driver?.rate === null ? (
                  <p>Aucune note livreur disponible</p>
                ) : (
                  <div
                    style={{
                      width: 150
                    }}
                  >
                    <Tag>
                      <span>{row?.rate_driver?.rate + " étoiles"}</span>
                      <br />
                      <span>{row?.rate_driver?.text}</span>
                    </Tag>
                  </div>
                )}
              </div>
              <h2
                style={{
                  marginTop: 20
                }}
              >
                Détails de la facturation
              </h2>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row"
                }}
              >
                {/* gain total */}

                <div
                  style={{
                    width: 150
                  }}
                >
                  <span>
                    Total:{" "}
                    <b> {"$" + row?.billing_details?.amount?.toFixed(2)} </b>
                  </span>
                  <br />
                  <span>
                    Livraison:{" "}
                    <b>
                      {"$" +
                        row?.billing_details?.delivery_price?.toFixed(2)}{" "}
                    </b>
                  </span>
                  <br />
                  <span>
                    <b>Taxe: {"$" + row?.billing_details?.tax?.toFixed(2)} </b>
                  </span>
                  <br />
                  <span>
                    <b>Tips: {"$" + row?.billing_details?.tip?.toFixed(2)} </b>
                  </span>
                  <br />
                  <span>
                    <b>
                      Date de livraion:{" "}
                      {row?.billing_details?.delivery_date}{" "}
                    </b>
                  </span>
                </div>
                {/* gain pani */}
                <div
                  style={{
                    width: 150
                  }}
                >
                  <span>
                    Gain Pani sur plat:{" "}
                    <b>
                      {"$" + row?.billing_details?.earned_pani?.toFixed(2)}{" "}
                    </b>
                  </span>
                  <br />
                  <span>
                    Gain Pani sur livraison:{" "}
                    <b>
                      {"$" +
                        row?.billing_details?.earn_delivery_pani?.toFixed(
                          2
                        )}{" "}
                    </b>
                  </span>
                </div>
                {/* gain pani */}
                <div
                  style={{
                    width: 150
                  }}
                >
                  <span>
                    Gain Chef:{" "}
                    <b>
                      {"$" + row?.billing_details?.earned_chef?.toFixed(2)}{" "}
                    </b>
                  </span>
                </div>
                {/* gain livreur */}
                <div
                  style={{
                    width: 150
                  }}
                >
                  <span>
                    Gain Livreur:{" "}
                    <b>
                      {"$" +
                        row?.billing_details?.earn_deliverman?.toFixed(2)}{" "}
                    </b>
                  </span>
                </div>
              </div>
              <h2
                style={{
                  marginTop: 20
                }}
              >
                Pickup & Livraison
              </h2>
              <div
                style={{
                  width: "100%"
                }}
              >
                <div style={{}}>
                  <span>
                    Lieu de collecte: <br />
                    <b>
                      {row?.chef_id?.street +
                        ", " +
                        row?.chef_id?.city +
                        ", " +
                        row?.chef_id?.number +
                        ", " +
                        row?.chef_id?.instruction +
                        " (" +
                        row?.chef_id?.position?.lat +
                        "&" +
                        row?.chef_id?.position?.lng +
                        ")"}
                    </b>
                  </span>
                </div>{" "}
                <br />
                <div style={{}}>
                  <span>
                    Lieu de Livraison: <br />
                    <b>
                      {row?.delivery_details?.street_name +
                        ", " +
                        row?.delivery_details?.line_address +
                        ", " +
                        row?.delivery_details?.receiver_name +
                        ", " +
                        row?.delivery_details?.phone_number +
                        ", " +
                        row?.delivery_details?.instruction +
                        " (" +
                        row?.delivery_details?.lat +
                        "&" +
                        row?.delivery_details?.lng +
                        ")"}
                    </b>
                  </span>
                </div>
              </div>
            </div>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Order_details;
